import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { OpenChartProviderCounter } from "modules/open-charts/types";

function useMyOpenChartsProviderCounter() {
  return useAxiosQuery(["openChartProviderCounter", {}], () =>
    axiosChartInstance.get<OpenChartProviderCounter>(
      `v1/open-charts/count/provider`,
      {}
    )
  );
}

export { useMyOpenChartsProviderCounter };
